/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'rarely' }, { id: 'yearly' }, { id: 'fewYear' }, { id: 'constantly' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-change-frequency"
      progress={64}
      field="hairstyleChangeFrequency"
      setter="setHairstyleChangeFrequency"
      ns="hairstyleChangeFrequency"
      options={OPTIONS}
    />
  );
}

export default Page;
